import React from 'react';
import { Field } from 'redux-form';
import Icon from '../../common/icons/Icon';

const renderVideoSection = ({ input, label, type, meta: { touched, error } }) => (
  <span className="lesson-sections__li__input-wrapper">
    <label>{label}</label>
    <span className="lesson-sections__li__input">
      <input {...input} type={type} placeholder={label} />
      {touched && error && <span className="input-validation">{error}</span>}
    </span>
  </span>
);

export default ({ fields, meta: { touched, error, submitFailed } }) => (
  <div className="admin-paper__lesson-sections">
    <div className="lesson-sections__header">
      <div>
        <h3>Lesson Sections</h3>
        <h5>Enter your section title and start time (ex. "3:30" for 3 minutes and 30 seconds)</h5>
      </div>
      <button
        type="button"
        onClick={e => {
          e.preventDefault();
          return fields.push({});
        }}
        className="admin__add-button"
      >
        <Icon icon="Plus" /> Add Section
      </button>
    </div>
    <ul>
      <li>{(touched || submitFailed) && error && <span>{error}</span>}</li>
      {fields.map((section, index) => (
        <li key={index} className="lesson-sections__li">
          <div>
            <Field name={`${section}.text`} type="text" component={renderVideoSection} label="Section Title" />
            <Field name={`${section}.startTime`} type="text" component={renderVideoSection} label="Start Time" />
          </div>
          <span onClick={() => fields.remove(index)} className="lesson-sections__li__delete">
            <Icon icon="Trash" />
          </span>
        </li>
      ))}
    </ul>
  </div>
);



// WEBPACK FOOTER //
// ./src/courses/lessons/LessonVideoSections.js